import React from 'react';
import { Link } from 'react-router-dom';


export default function LinkolnEmail({ linkoln_email }) {
  const viewed = linkoln_email.status === "viewed";
  const created_str = new Intl.DateTimeFormat().format(new Date(linkoln_email.created));

  return (
    <tr className="align-middle">
      <td><font face="Wingdings" color={viewed ? "#0B0" : "#B00"} size="6">{viewed ? "/" : ","}</font></td>
      <td>{ linkoln_email.title }<br/><span style={{ fontSize: "12px" }}>posted on { created_str }</span></td>
      <td>{ linkoln_email.url } (<a target="_blank" rel="noreferrer" href={ linkoln_email.preview_url }>proof message</a>)</td>
      <td><Link to={"/views/" + linkoln_email.short_id }>View Report</Link></td>
      <td className="text-center"><span className="copy_link btn btn-danger btn-sm fw-normal text-white d-inline-block text-nowrap" data-bs-toggle="modal" data-bs-target="#copyModal" onClick={() => navigator.clipboard.writeText(linkoln_email.url)}>Copy Link</span></td>
    </tr>
  );
}
